module.exports = __webpack_public_path__ + "img/Pragmatic.7074b0c9.jpg";